<template>
    <div>
        <Label class="mb-2 gap-1 flex items-center" for="country"
            >{{ $t("billing.billing_information.country") }}

            <RequiredStarIcon v-if="required" />
        </Label>

        <select
            id="countries"
            v-model="country"
            class="focus-with:ring-z-primary-100 rounded-lg border-iron-300 text-sm focus-within:border-z-primary-300 focus:ring-z-primary-100 w-full py-[9px] outline-none focus-within:ring-2 focus-within:outline-none focus:outline-none"
            name="countries"
        >
            <option v-for="c of countries" :key="c.value" :value="c.value">
                {{ c.label }}
            </option>
        </select>
    </div>
</template>

<script setup lang="ts">
import { Label } from "@/components/ui/label";
import { countries } from "./countries";
import RequiredStarIcon from "./RequiredStarIcon.svg";
interface Props {
    required?: boolean;
}

defineProps<Props>();

const country = defineModel<string>();
</script>
